export const NONE = "NONE";
export const FIRST_NAME = "FIRST_NAME";
export const FIRST_AND_LAST_NAME = "FIRST_AND_LAST_NAME";
export const NAME_AND_LOCATION = "NAME_AND_LOCATION";
export const ONLY_YOU_LAYOUT = 3;